"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var helper_1 = require("../../utils/helper");
var util_1 = require("../Checkbox/util");
var Radio_1 = tslib_1.__importDefault(require("./Radio"));
var theme_1 = require("../../utils/theme");
var Group = (function (_super) {
    tslib_1.__extends(Group, _super);
    function Group() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: _this.props.defaultValue
        };
        _this.handleSingleChange = function (checked, e) {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({ value: e.target.value });
            _this.props.onChange(e.target.value, e);
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, itemStyle = _a.itemStyle;
            var cls = classNames(prefixCls, className);
            return (h("div", { className: cls, style: style }, util_1.renderChildren(_this.props, [_this.state.value], _this.handleSingleChange, Radio_1.default, itemStyle)));
        };
        return _this;
    }
    Group.getDerivedStateFromProps = function (props, state) {
        if ('value' in props) {
            return { value: props.value };
        }
        return null;
    };
    Group.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Group;
}(React.Component));
exports.default = Group;
Group.defaultProps = {
    prefixCls: 'dui-radio-group',
    disabled: false,
    onChange: helper_1.emptyFn
};
Group.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    options: PropTypes.array,
    disabled: PropTypes.bool,
    defaultValue: PropTypes.any,
    value: PropTypes.any,
    onChange: PropTypes.func,
    itemStyle: PropTypes.object,
    children: PropTypes.node
};
